// import { Image, Video } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
// import { TutorialCardContainer } from "../ui/tutorial-card";
import { DiscussionEmbed } from "disqus-react";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import { CardContainer } from "@/components/ui/card";
import { useQuery } from "@tanstack/react-query";
import { useUser, useSupabaseClient } from "@supabase/auth-helpers-react";
import { Comments, NewsletterForm } from "@hyvor/hyvor-talk-react";
import { useUsername } from "@/hooks/useUsername";
import { Spinner } from "@/components/ui/spinner";

interface Comment {
  author: string;
  time: string;
  content: string;
}

interface TutorialCommentsProps {
  comments: Comment[];
  tutorialId: string;
  tutorialTitle: string;
}

export const TutorialComments = ({
  comments,
  tutorialId,
  tutorialTitle,
}: TutorialCommentsProps) => {
  const { i18n } = useTranslation();
  const location = useLocation();
  const [key, setKey] = useState(0);
  const user = useUser();
  const now = Math.floor(Date.now() / 1000);
  const { data: username, isLoading: isUsernameLoading } = useUsername(
    user?.id
  );

  // TODO: implement key-based SSO
  // const supabase = useSupabaseClient();
  // const { data: ssoData } = useQuery({
  //   queryKey: ['hyvorTalkSso', user?.id],
  //   queryFn: async () => {
  //     if (!user) return null;
  //     const { data: { session } } = await supabase.auth.getSession();
  //     if (!session) return null;

  //     const { data, error } = await supabase.functions.invoke('hyvor-talk-sso', {
  //       method: 'GET',
  //       headers: {
  //         Authorization: `Bearer ${session.access_token}`,
  //         'Content-Type': 'application/json'
  //       }
  //     });

  //     if (error) throw error;
  //     return data;
  //   },
  //   enabled: !!user,
  // });
  // console.log(ssoData);

  // Reset the component when language changes
  useEffect(() => {
    setKey((prev) => prev + 1);
  }, [i18n.language]);

  if (isUsernameLoading || !username)
    return (
      <CardContainer className="flex items-center justify-center h-20">
        <Spinner size="lg" />
      </CardContainer>
    );

  return (
    <CardContainer>
      <div key={key} className="text-foreground">
        <Comments
          website-id={12515}
          page-id={tutorialId}
          page-language={i18n.language}
          sso-user={(() => {
            // Convert the object to a JSON string
            const jsonString = JSON.stringify({
              timestamp: now,
              id: user?.id,
              name: username,
              email: user?.email,
              picture_url: user?.user_metadata?.avatar_url,
            });
            // Convert string to UTF-8 array and then to base64
            // This handles Cyrillic and other non-Latin characters properly
            return btoa(unescape(encodeURIComponent(jsonString)));
          })()}
          // sso-hash={ssoData?.hash}
        />
      </div>
    </CardContainer>
  );
};
